import React from "react";
import { Helmet } from "react-helmet";

const ServiceSchema = ({ 
  serviceName, 
  serviceDescription, 
  serviceUrl,
  serviceType = "Service"
}) => {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": serviceType,
    "name": serviceName,
    "description": serviceDescription,
    "url": serviceUrl,
    "provider": {
      "@type": "Organization",
      "name": "Kinetx Co",
      "url": "https://www.kinetx.co"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Miami",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Miami",
          "addressRegion": "FL",
          "addressCountry": "US"
        }
      },
      {
        "@type": "City",
        "name": "New York City",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "New York",
          "addressRegion": "NY",
          "addressCountry": "US"
        }
      }
    ],
    "serviceType": serviceName,
    "category": "IT Services"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
      <link rel="canonical" href={serviceUrl} />
    </Helmet>
  );
};

export default ServiceSchema;

